module.exports = __webpack_public_path__ + "static/media/two-bed-luxury-bg-1.d5fb761a.jpg";